import React, { Component } from "react";

import "./StatSquare.css";

export default class StatSquare extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
        <th className="StatSquare">{ this.props.value }</th>
      );
  }
}



// WEBPACK FOOTER //
// ./src/containers/StatSquare.js